import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS } from '../../_config';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import Icon from '../../components/icons';

const ResetPassword: React.FC = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [cshowPassword, setCShowPassword] = useState(false);

    const userAPI: any = useUserApi();
    const { register, formState: { errors }, handleSubmit, watch } = useForm<any>();
    const navigate = useNavigate();
    const params: any = useParams();

    const password = watch("password"); 

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleCPassword = () => {
        setCShowPassword(!cshowPassword); 
    };

    const resetPassword = (data: any) => {
        // userAPI.resetPassword({ ...data, email: atob(params.email) }, (response: any) => {
        //     console.log('response =>', response);
        //     toast.success('Password reset successfully');
        //     navigate(URLS.LOGIN);
        // }, (error: any) => {
        //     toast.error(error);
        //     console.log('error =>', error);
        // });
    };

    return (
        <div className="flex min-h-screen">
            {/* Left Side: Form Section */}
            <div className="flex flex-col justify-center items-center w-full lg:w-4/12 sm:w-4/12 px-6 py-12 lg:px-8 bg-white">
                <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-[92px]" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-800">Reset your  HubWallet Password</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Set your password please</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(resetPassword)}>
                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    {...register("password", { required: true })}
                                    autoComplete="current-password" placeholder='New Password'
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.password ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name={showPassword ? 'eye' : 'eye-off'} size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" onClick={togglePassword} />
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type={cshowPassword ? 'text' : 'password'}
                                    {...register("confirmPassword", {
                                        required: "Confirm Password is required",
                                        validate: value => value === password || "Passwords do not match",
                                    })}
                                    autoComplete="current-password" placeholder='Confirm Password'
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.cpassword ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name={cshowPassword ? 'eye' : 'eye-off'} size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" onClick={toggleCPassword} />
                            </div>
                            {errors.confirmPassword && (
                                <span className="text-red-500 text-xs">Passwords do not match</span>
                            )}
                        </div>


                        <div className='mb-5'>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 p-4 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >Submit</button>
                        </div>
                    </form>

                    <p className="text-center text-sm/6 text-gray-500">
                        <Link to={URLS.USER.LOGIN} className="font-semibold text-blue-600 hover:text-blue-500">Back to Login</Link>
                    </p>
                </div>
            </div>

            <div className="hidden sm:block lg:w-8/12 sm:w-8/12 bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009.jpg)' }}>
            </div>
        </div>

    );
};

export default ResetPassword;